import pjson from '../../package.json';

class HelperEnv {

	static getUriSimulationCalculation(vehDescType) {
		if (vehDescType === 'ANYBRAND') {
			return '/financialsimulation/anybrandvehicle/simulationdetails';
		}
		return '/financialsimulation/vehiclesimulationdetails';
	}
	static getUriSimulationCriteria(vehDescType) {
		if (vehDescType === 'ANYBRAND') {
			return '/financialsimulation/anybrandvehicle/offer/criteria';
		}
		return '/financialsimulation/offer/criteria';
	}
	static getUriServiceLevels(vehDescType) {
		if (vehDescType === 'ANYBRAND') {
			return '/financialsimulation/anybrandvehicle/offer/servicelevels';
		}
		return '/financialsimulation/offer/servicelevels';
	}
	static getUriSimulationOffers(vehDescType) {
		if (vehDescType === 'ANYBRAND') {
			return '/financialsimulation/anybrandvehicle/offers';
		}
		return '/financialsimulation/offers';
	}
	static getUriSimulationOptions() { return '/financialsimulation/optionsrental'; }
	static getUriSimulationAccessories() { return '/financialsimulation/accessoriesincrease'; }
	static getUriSimulationVehiclesConfig() { return '/financialsimulation/multiplevehiclerentals'; }
	static getUriSimulationVehiclesStock(vehDescType) {
		if (vehDescType === 'ANYBRAND') {
			return '/financialsimulation/anybrandvehicles/multipleteasers';
		}
		return '/financialsimulation/multiplestockvehiclesrentals';
	}
	static getUriVersion() { return '/application/version'; }
	static getUriRoutingInformation(distributionBrand, countryCode, customerMarket) { return `/application/${distributionBrand}/${countryCode}/${customerMarket}/routingInfo`; }
	static getBasePath() { return '/application/'; }
	static getUriFinanceFile(settings) {
		if (settings.finfileResource === 'QUOTATION') {
			if (settings.vehDescType === 'ANYBRAND') {
				return '/financialquotation/anybrandvehicle/quotationdetails/raw';
			}
			return '/financialquotation/lcdvVehicle/quotationdetails/raw';
		}else if (settings.vehDescType === 'ANYBRAND') {
			return '/financefile/anybrandvehicle/financedetails';
		}
		return '/financefile/financedetails';
	}

	static getBasePathSimulation() { return '/onlinefinance-simulation/v2'; }
	static getBasePathOffer() { return '/onlinefinance-simulation-offer/v1'; }
	static getBasePathFinanceFile(settings) {
		if(settings.finfileResource === 'QUOTATION'){
			return '/onlinefinance-quotation/v1';
		}
		return '/onlinefinance-financefile/v1';
	}
	static getBasePathLocal() { return '/rest'; }
	static getEnabledConditionTestVehicles() { return process.env.REACT_APP_WID_FINANCE_GWCALCTEST_ENABLE_TEST_VEHICLES; }

	static isEnabledTestVehicles(env) {
		return HelperEnv.getEnabledConditionTestVehicles() === 'true'
			|| (HelperEnv.getEnabledConditionTestVehicles() === 'authenticated' && HelperEnv.isAuthenticationSet(env));
	}
	static isEnableDoc() { return process.env.REACT_APP_WID_FINANCE_GWCALCTEST_ENABLE_DOC; }
	static getDefaultContext() { return process.env.REACT_APP_WID_FINANCE_GWCALCTEST_DEFAULT_CONTEXT ? process.env.REACT_APP_WID_FINANCE_GWCALCTEST_DEFAULT_CONTEXT : {} }
	static getWidgetBaseUrl() { return process.env.REACT_APP_WID_FINANCE_WID_BASE_URL; }
	static getWidgeSFSBaseUrl() { return process.env.REACT_APP_WID_FINANCE_WIDSFS_BASE_URL; }

	static getEnvNetworkZones() {
		const strJson = process.env.REACT_APP_WID_FINANCE_NETWORK_ZONES;
		if (strJson.length > 0) {
			return JSON.parse(strJson);
		}
		return [];
	}
	static getEnvNetworkZoneDefault() {
		const networkZones = HelperEnv.getEnvNetworkZones();
		for (const k in networkZones) {
			if (!networkZones[k].isAuth) {
				return networkZones[k];
			}
		}
		return networkZones[0];
	}
	static getEnvNetworkZone(name) {
		const networkZones = HelperEnv.getEnvNetworkZones();
		for (const key in networkZones) {
			if (name === networkZones[key].code) {
				return networkZones[key];
			}
		}
		return {};
	}

	static getPathEnvVariables() {
		const simuIsLocal = process.env.REACT_APP_WID_FINANCE_GWCALCTEST_IS_LOCAL;
		let isAuthSimu = false;
		if (process.env.REACT_APP_WID_FINANCE_GWCALCTEST_ISAUTH === 'true') {
			isAuthSimu = true;
		}
		var envConfig = {
			envLabel: process.env.REACT_APP_WID_FINANCE_GWCALCTEST_ENV_LABEL,
			envSuffix: process.env.REACT_APP_WID_FINANCE_GWCALCTEST_ENV_SUFFIX,
			envTheme: process.env.REACT_APP_WID_FINANCE_GWCALCTEST_ENV_THEME,
			urlBaseAppIntranet: process.env.REACT_APP_WID_FINANCE_APPINTRANET_URL + HelperEnv.getBasePathLocal()
		};
		if (simuIsLocal === '1') {
			envConfig = { ...envConfig, isLocal: 1 };
		}
		envConfig.isAuthSimu = isAuthSimu;
		envConfig.gwtestVersion = HelperEnv.getGwcalctestVersionText(pjson);
		return envConfig;
	}

	static getGwcalctestVersionText(pjson) {
		if (pjson && pjson.version) {
			return `gwcalctest version: ${pjson.version}`;
		}
		return null;
	}

	static isAuthSimulationPublic(env, settings) {
		return HelperEnv.isAuthenticationSet(env) &&
			(env.isAuthSimu === 'true' || settings.networkZone.isAuth);
	}

	static getSimulationBaseUrl(env, settings) {
		if (env.isLocal) {
			return HelperEnv.getUrlBaseSimuRoot(settings);
		}
		return HelperEnv.getUrlBaseSimuRoot(settings) + HelperEnv.getBasePathSimulation();
	}
	static getOfferBaseUrl(env, settings) {
		if (env.isLocal) {
			return HelperEnv.getUrlBaseSimuRoot(settings);
		}
		return HelperEnv.getUrlBaseSimuRoot(settings) + HelperEnv.getBasePathOffer();
	}
	static getWidgetInputBaseUrl(settings) {
		return HelperEnv.getUrlBaseSimuRoot(settings);
	}
	static getSimuClientId(settings) {
		const networkZone = settings.networkZone;
		return networkZone.clientId;
	}

	static getUrlBaseSimuRoot(settings) {
		const simuIsLocal = process.env.REACT_APP_WID_FINANCE_GWCALCTEST_IS_LOCAL;
		const networkZone = settings.networkZone;
		if (simuIsLocal === '1') {
			return networkZone.url + HelperEnv.getBasePathLocal();
		} else {
			return networkZone.url
		}
	}

	static getUrlBaseFinanceFile(settings) {
		const simuIsLocal = process.env.REACT_APP_WID_FINANCE_GWCALCTEST_IS_LOCAL;
		const networkZone = settings.networkZone;
		if (simuIsLocal === '1') {
			return networkZone.url + HelperEnv.getBasePathLocal();
		} else if (networkZone.isAuth) {
			return networkZone.url + HelperEnv.getBasePathFinanceFile(settings);
		} else {
			const fallBack = networkZone.authFallback;
			const authNetworkZone = HelperEnv.getEnvNetworkZone(fallBack);
			return authNetworkZone.url + HelperEnv.getBasePathFinanceFile(settings);
		}
	}
	static getFinanceFileClientId(settings) {
		const networkZone = settings.networkZone;
		if (networkZone.isAuth) {
			return networkZone.clientId;
		} else {
			const fallBack = networkZone.authFallback;
			const authNetworkZone = HelperEnv.getEnvNetworkZone(fallBack);
			return authNetworkZone.clientId;
		}
	}

	static isAuthenticationSet(env) {
		return env.financeFileProps != null
			&& env.financeFileProps.username && env.financeFileProps.password;
	}

	static isFetchPossible(env, settings) {
		if (env.isAuthSimu === true) {
			return HelperEnv.getUrlBaseFinanceFile(settings) && (HelperEnv.getFinanceFileClientId(settings) || env.isLocal)
				&& HelperEnv.isAuthenticationSet(env)
				&& env.resultStatus && (env.resultStatus.resHttpStatus === 200 || env.resultStatus.resHttpStatus === 0)
		}
		return HelperEnv.getSimulationBaseUrl(env, settings) != null && (HelperEnv.getSimuClientId(settings) != null || env.isLocal)
	}

	static retrieveWidgetBPFVersion() {
		const n = document.getElementById('wid00bpf-fipsa-widget-modal');
		if (n != null) {
			for (const child of n.children) {
				if (child.tagName === 'SPAN') {
					return child.textContent;
				}
			}
		}
		return null;
	}

	static getEnvGatewayTestList() {
		const strJson = process.env.REACT_APP_WID_FINANCE_GWCALCTEST_DOC_ENVIRONMENTS_LIST;
		if (strJson.length > 0) {
			return JSON.parse(strJson);
		}
		return {};
	}
}

export default HelperEnv
